'use client'

export {
  usePaginationTelemetry,
  useQueryTelemetry,
} from '@brew/observability/browser'
